import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IUser} from '../../../commons/interfaces/user/user';
import {INotification} from '../../../commons/interfaces/notifications/INotification';
import {IResultResponse} from '../../../commons/interfaces/IResultResponse';

export interface INotificationFilter {
  pageNumber: number;
  pageSize: number;
  pageSizes: number[];
  seen: boolean;
}

class NotificheController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    '$timeout'
  ];

  constructor(
    private $scope: {
      notSeenToggle: boolean;
      seeAll: () => void;
      notSeen: () => void;
      disabled: boolean;
      seen: (item: INotification) => void;
      getNotification: () => void;
      pageHeader: string;
      notifications: IResultResponse<INotification>
      filter: INotificationFilter,
      messages: {
        type: string,
        queueName: string,
        details: any,
        _id: string,
        message: string
      }[]
    },
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService
  ) {
    $scope.pageHeader = 'Notifiche';
    $scope.notifications = undefined;
    $scope.filter = {
      pageSizes: [20, 50, 100],
      pageNumber: 1,
      pageSize: 20,
      seen: true,
    };
    $scope.disabled = false;
    $scope.notSeenToggle = false;

    $scope.getNotification = () => {
      $scope.disabled = true;
      ArchiSmallServices.notifications((store.get('user') as IUser).accountData.email, $scope.filter).then(res => {
        $scope.notifications = JSON.parse(JSON.stringify(res)) as IResultResponse<INotification>;
        $scope.messages = $scope.notifications.resultList.map(item => {
          return JSON.parse(item.message);
        });
      }).finally(() => $scope.disabled = false);
    };
    $scope.getNotification();

    $scope.seen = (item: INotification) => {
      $scope.disabled = true;
      item.seen = !item.seen;
      if (item.seenDate === undefined) {
        // @ts-ignore
        item.seenDate = new Date();
      }
      if (!$scope.filter.seen) {
        const id = $scope.notifications.resultList.findIndex(notification => notification._id === item._id);
        $scope.notifications.resultList.splice(id, 1);
        $scope.messages.splice(id, 1);
        $scope.notifications.itemsCount = $scope.notifications.itemsCount - 1;
      }
      ArchiSmallServices.notificationUpdate([item]).finally(() => $scope.disabled = false);
    };

    $scope.seeAll = () => {
      $scope.disabled = true;
      ArchiSmallServices.notificationConsumeAll().then(_res => $scope.getNotification());
    };
  }

}

export const NotificheComponent: ng.IComponentOptions = {
  template: require('./notifiche.html'),
  controller: NotificheController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/notifiche/notifiche.ts